import { request, requestUpload } from '../../utils'

export const uploadHandout = (liveId, file, onProgress) => {
  const url = '/api/live/attachment/upload'

  return requestUpload({
    url,
    files: [['file', file]],
    data: {
      live_id: liveId,
    },
    onProgress,
  })
}

export const fetchHandouts = (liveId, token) => {
  return request({
    url: '/api/live/attachment/list',
    method: 'GET',
    data: {
      live_id: liveId,
      token,
    },
  })
}

export const removeHandout = (liveId, filename) => {
  return request({
    url: '/api/live/attachment/delete',
    method: 'POST',
    data: {
      live_id: liveId,
      filename,
    },
  })
}
